
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { ArrowLeft } from "lucide-react";
import { useTranslation } from "@/hooks/useTranslation";

interface LensDetailsErrorProps {
  error: string | null;
  onBackClick: () => void;
}

export function LensDetailsError({ error, onBackClick }: LensDetailsErrorProps) {
  const { t } = useTranslation();
  
  return (
    <div className="container py-6 space-y-6 max-w-[1200px] mx-auto">
      <div className="flex items-center gap-2 mb-6">
        <Button variant="outline" size="sm" onClick={onBackClick}>
          <ArrowLeft className="h-4 w-4 mr-1" />
          {t('back_to_lenses')}
        </Button>
      </div>
      
      <Card className="border-destructive">
        <CardHeader>
          <CardTitle>{t('error')}</CardTitle>
          <CardDescription>{t('failed_load_lens')}</CardDescription>
        </CardHeader>
        <CardContent>
          <p>{error || t('lens_not_found')}</p>
        </CardContent>
      </Card>
    </div>
  );
}
